/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Nav_Cta_ShortInputs */

const en_mk_nav_cta_short = /** @type {(inputs: Mk_Nav_Cta_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try free`)
};

const id_mk_nav_cta_short = /** @type {(inputs: Mk_Nav_Cta_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coba gratis`)
};

/**
* | output |
* | --- |
* | "Try free" |
*
* @param {Mk_Nav_Cta_ShortInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_nav_cta_short = /** @type {((inputs?: Mk_Nav_Cta_ShortInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Nav_Cta_ShortInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_nav_cta_short(inputs)
	return en_mk_nav_cta_short(inputs)
});